import { Injectable } from '@angular/core';
import { FormControl } from '@angular/forms';
import { UsersService } from '../services/users/users-service';

@Injectable()
export class UserEmailExistsValidator {

  debouncer: any;
  private id: number|null;

  excludeId(id: number|null) {
    this.id = id;
    return {checkEmail: this.checkEmail};
  }

  checkEmail(control: FormControl): any {
    let self: UserEmailExistsValidator = this;
    return new Promise(resolve => {
      this.debouncer = setTimeout(() => {
        this.usersService
          .search({email: String(control.value).trim()})
          .subscribe(
            (res) => {
              if(res.filter(function(r){
                return String(r.email).trim().toLowerCase() === String(control.value).trim()
                   && (self.id && self.id>0 ? self.id.toString() !== r.id.toString() : true);
              }).length > 0) {
                resolve({"email_taken": true});
              }
              else {
                resolve(null);
              }
            },
            (err) => {
              resolve({"can't reach server": true});
            });
      }, 350);
    });
  }

  constructor(public usersService: UsersService) {}
}



// WEBPACK FOOTER //
// ./src/validators/user-email-exists.ts